
export class AppOAuthStore {
    private readonly storage: Storage;
  
    constructor(private readonly appName: string) {  
      if (typeof localStorage !== 'undefined') {
        this.storage = localStorage;
      }
      this.storage.setItem(`${this.appName}|app_name`, this.appName)
    }
  
    getItem(key) {
      return this.storage.getItem(`${this.appName}|${key}`);
    }
  
    setItem(key, data) {
      return this.storage.setItem(`${this.appName}|${key}`, data);
    }

    getObject(key) {
      return JSON.parse(this.storage.getItem(`${this.appName}|${key}`));
    }

    setObject(key, data) {
      return this.storage.setItem(`${this.appName}|${key}`, JSON.stringify(data));
    }
  
    removeItem(key) {
      return this.storage.removeItem(`${this.appName}|${key}`);
    }

    clear(){
      Object.entries(this.storage).map( x => x[0] ).filter(
          x => x.substring(0,this.appName.length) == this.appName
      ).map( x => {
        if(x!==`${this.appName}|dispositivoAutorizado`)
          this.storage.removeItem(x);
      } );
    }
}